if (!customElements.get('collection-sort')) {
  class CollectionSort extends HTMLElement {
    constructor() {
      super();

      this.handleSortChangeRef = this.handleSortChange.bind(this);
    }

    handleSortChange(event) {
      if (!event.target.value) return;

      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      const urlToString = url.toString();
      url.searchParams.set('sections', this.getAttribute('data-sections'));

      fetch(url.toString())
        .then((res) => res.json())
        .then((data) => {
          document.dispatchEvent(
            new CustomEvent('exo:update-collection-items', {
              detail: {
                id: this.getAttribute('data-id'),
                html: data.collection,
              },
            }),
          );

          history.replaceState({}, '', urlToString);
        })
        .catch((err) => console.error(err));
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleSortChangeRef);
    }

    connectedCallback() {
      this.addEventListener('change', this.handleSortChangeRef);
    }
  }

  customElements.define('collection-sort', CollectionSort);
}
